import styled from 'styled-components';
import { Tooltip } from 'antd';
import { gray1 } from '@styles/styled/variables';

export const Wrapper = styled.h2`
  color: ${gray1};
`;

export const FilterCreation = styled.span`
  font-weight: normal;
  padding-left: 16px;
  font-style: italic;
  font-size: 14px;
`;

export const FilterName = styled(Tooltip)`
  font-weight: bold;
  margin-left: 20px;
`;
